/* DS 418 / BR18 heat-loss helpers
   ------------------------------------------------------------- */

export function rowHeatLoss(row) {
    if (!row.UorPsi || !row.AorL || !Number.isFinite(row.Ti) || !Number.isFinite(row.Te))
        return 0;

    const dT = row.Ti - row.Te;
    return row.partKind === 'line'
        ? row.UorPsi * row.AorL * dT           // Ψ [W/mK] × length [m]
        : row.UorPsi * row.AorL * dT;          // U [W/m²K] × area [m²]
}

export const sumLoss = rows =>
    rows.reduce((s, r) => s + rowHeatLoss(r), 0);
